import { render } from "./IconProtfolio.vue?vue&type=template&id=7d57d84e"
import script from "./IconProtfolio.vue?vue&type=script&lang=js"
export * from "./IconProtfolio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__